import React from 'react';
import { Button, Form, Input, Icon, Modal } from 'antd';
import PropTypes from 'prop-types';
import { sanitizeFieldName } from '../../util/methods';
import moment from "moment";
import AddPhoto from './Photos'
import ImagePreviewModal from '../ImagePreviewModal'
import EditFieldModal from './EditFieldModal'

const { TextArea } = Input;

class SubList extends React.Component {

  id = 0;

  state = {
    keys: [],
    documentData: {},
    photoPreview: { visible: false, index: 0, photos: [] },
    editModal: { visible: false, field: '', index: 0, tempAssetCode: '', currentValue: undefined },
  };

  openEditModal = (field, index, tempAssetCode, currentValue) => {
    this.setState({ editModal: { visible: true, field, index, tempAssetCode, currentValue } });
  };

  closeEditModal = () => {
    this.setState((prev) => ({ editModal: { ...prev.editModal, visible: false } }));
  };

  handleFieldSave = (field, value) => {
    const { editModal } = this.state;
    const payload = {
      _id: this.props.pv,
      tempAssetCode: editModal.tempAssetCode,
      [field]: value,
    };
    if (this.props.onUpdateAssetDetailField) {
      this.props.onUpdateAssetDetailField(payload);
    }
    this.closeEditModal();
  };

  getConditionOptions = () => {
    const { item } = this.props;
    return (item && item.schema && item.schema.physicalCondition
      && item.schema.physicalCondition.data && item.schema.physicalCondition.data.data) || [];
  };

  editIconTitles = {
    physicalCondition: 'Physical Condition',
    qty: 'Number Of Quantity',
    parentAssetCode: 'Parent Asset Code',
  };

  renderEditIcon = (field, index, tempAssetCode, currentValue) => {
    // Only editable on the VIEW page, when the record is not yet approved
    if (this.props.title !== 'VIEW' || this.props.isApproved) {
      return null;
    }
    // Quantity is only relevant for countable records (non-countable are always qty 1)
    if (field === 'qty') {
      const record = this.props.data && this.props.data[index];
      if (!(record && record.countable)) {
        return null;
      }
    }
    return (
      <Icon
        type='edit'
        title={`Edit ${this.editIconTitles[field] || field}`}
        onClick={() => this.openEditModal(field, index, tempAssetCode, currentValue)}
        style={{ marginLeft: 8, color: '#1890ff', cursor: 'pointer' }}
      />
    );
  };

  // Remove is allowed on the VIEW page while the report is not submitted.
  canRemove = () => this.props.title === 'VIEW' && this.props.notSubmitted;

  confirmRemove = (assetDetailId, tempAssetCode) => {
    if (!assetDetailId && !tempAssetCode) return;
    Modal.confirm({
      title: 'Remove this record?',
      content: `Are you sure you want to remove ${tempAssetCode || 'this asset detail'} from the report?`,
      okText: 'Remove',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: () => {
        if (this.props.onRemoveAssetDetail) {
          this.props.onRemoveAssetDetail({ _id: this.props.pv, assetDetailId, tempAssetCode });
        }
      },
    });
  };

  openPhotoPreview = (photos, index) => {
    const list = (photos || [])
      .filter((p) => p && p.url)
      .map((p, i) => ({ url: p.url, name: p.name || `Attachment ${i + 1}` }));
    this.setState({ photoPreview: { visible: true, index, photos: list } });
  };

  closePhotoPreview = () => {
    this.setState((prev) => ({ photoPreview: { ...prev.photoPreview, visible: false } }));
  };

  componentDidMount() {
    const { data = [{}] } = this.props;
    this.setState({
      keys: data,
      sectionId: ''
    });
  }

  clearDocumentData() {
    this.setState({ documentData: {} });
  }

  getDocumentData = (index, data) => {
    this.props.form.setFieldsValue({ [`assetDetails[${index}][fileData]`]: data });
    this.setState({ documentData: data });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        keys: nextProps.data,
      });
    }
    if (nextProps.urlQueryCode) {
      this.setState({
        sectionId: nextProps.urlQueryCode
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const section = document.getElementById(this.state.sectionId);
    if (section) {
      // section.classList.add('highlighted');
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }

  remove = index => {
    const { keys } = this.state;
    const { form, item } = this.props;
    const { field } = item;
    if (keys.length === 1) {
      return;
    }
    const val = form.getFieldValue(field);
    val.splice(index, 1);

    keys.splice(index, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((item, index) => {
        form.setFieldsValue({
          [`${field}[${i}][${item}]`]: val[i][item],
        });
      });
    }
    this.setState({
      keys: keys,
    });
  };

  add = () => {
    const { item: { field } } = this.props;
    const { keys } = this.state;
    keys.push(`${field}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  render() {
    const {
      form,
      item,
      data = [],
      openedBy,
      resource,
      title,
      latitude,
      longitude,
      superMaster,
      subMaster,
      subDocumentFilters
    } = this.props;
    const { field } = item;
    const { getFieldDecorator, setFieldsValue } = form;
    const { keys } = this.state;
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '10px',
      borderRadius: '9px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      wordBreak: 'break-all',
    };

    const formItems = keys.map((k, index) => {
      const tempCode = data && data[index] && data[index]['tempAssetCode'] ? data[index]['tempAssetCode'] : '';
      // console.log('Rendering AddPhoto for index:', index, 'with tempCode:', tempCode);

      return (
        <div key={index} style={{
          marginTop: '10px',
          border: this.state.sectionId === tempCode ? '1px solid red' : '1px dashed #000',
          padding: '10px',
          borderRadius: '9px',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          wordBreak: 'break-all',
        }} id={tempCode}>
          <div className='assets-code-section'>
            <div className={'asset-details-location-stamp'}>
              <div className={'asset-details-section'}>
                <span
                  className={'asset-details-heading'}>Temp Code</span>:&nbsp; {tempCode}
              </div>

              <div className={'asset-details-section'}>
                <span
                  className={'asset-details-heading'}>QR Id</span>:&nbsp; {data && data[index] && data[index]['tempQrCode'] ? data[index]['tempQrCode'] : ''}
              </div>

              <div className={'asset-details-section'}>
                <span
                  className={'asset-details-heading'}>Tag Type</span>:&nbsp; {data && data[index] && data[index]['tag_type'] && data[index]['tag_type']['name'] ? data[index]['tag_type']['name'] : ''}
              </div>

              {
                (title === 'VIEW') && <div className={'asset-details-section'}>
                  <span className={'asset-details-heading'}>Entry Type</span>:&nbsp; {
                    (data && data[index] && !!data[index]['countable']) ? 'Countable' : 'Non Countable'}
                </div>
              }
              {
                (title === 'VIEW') && <div className={'asset-details-section'}>
                  <span className={'asset-details-heading'}>Time</span>:&nbsp; {
                    (data && data[index] && data[index]['time']) ? moment(data[index]['time']).format('MM-DD-YYYY hh:mm a') : ''}
                </div>
              }
              {
                (title === 'VIEW') && <div className={'asset-details-section'}>
                  <span className={'asset-details-heading'}>Asset Model</span>:&nbsp; {
                    (data && data[index] && data[index]['assetModel'] && data[index]['assetModel'].name) ? data[index]['assetModel'].name : 'NA'}
                </div>
              }
              {
                (title === 'VIEW') && <div className={'asset-details-section'}>
                  <span className={'asset-details-heading'}>Asset Type</span>:&nbsp; {
                    (data && data[index] && data[index]['assetType'] && data[index]['assetType'].name) ? data[index]['assetType'].name : 'NA'}
                </div>
              }
              {
                (title === 'VIEW') && <div className={'asset-details-section'}>
                  <span className={'asset-details-heading'}>Asset Sub Type</span>:&nbsp; {
                    (data && data[index] && data[index]['equipmentSubType'] && data[index]['equipmentSubType'].name) ? data[index]['equipmentSubType'].name : 'NA'}
                </div>
              }
              <div className={'asset-details-section'}>
                <span
                  className={'asset-details-heading'}>{sanitizeFieldName(item.schema['qty'].options.label ? item.schema['qty'].options.label : item.schema['qty'].field)}</span>:&nbsp;
                {data && data[index] && data[index]['qty'] ? data[index]['qty'] : 'NA'}
                {this.renderEditIcon('qty', index, tempCode, data && data[index] ? data[index]['qty'] : undefined)}
              </div>

              <div className={'asset-details-section'}>
                <span
                  className={'asset-details-heading'}>{sanitizeFieldName(item.schema['parentAssetCode'].options.label ? item.schema['parentAssetCode'].options.label : item.schema['parentAssetCode'].field)}</span>:&nbsp;
                {data && data[index] && data[index]['parentAssetCode'] ? data[index]['parentAssetCode'] : 'NA'}
                {this.renderEditIcon('parentAssetCode', index, tempCode, data && data[index] ? data[index]['parentAssetCode'] : undefined)}
              </div>

            </div>

            <div className={'asset-details-section-two'}>
              <span
                className={'asset-details-heading'}>{sanitizeFieldName(item.schema['physicalCondition'].options.label ? item.schema['physicalCondition'].options.label : item.schema['physicalCondition'].field)}</span>:&nbsp;
              {data && data[index] ? data[index]['physicalCondition'] && (data[index]['physicalCondition'].name || data[index]['physicalCondition']) : ''}
              {this.renderEditIcon('physicalCondition', index, tempCode, (data && data[index] && data[index]['physicalCondition'] && data[index]['physicalCondition']._id) ? data[index]['physicalCondition']._id : undefined)}
            </div>

            <div className={'asset-details-location-stamp'}>
              <div className={'asset-details-section'}>
                <span className={'asset-details-heading'}>Entered By</span>:&nbsp;
                {data && data[index] ? ((data[index]['user'] && data[index]['user'] && data[index]['user'].name) || (openedBy && openedBy.name)) : ''}
              </div>
              <div className={'asset-details-section'}>
                <span
                  className={'asset-details-heading'}>{sanitizeFieldName(item.schema['latitude'].options.label ? item.schema['latitude'].options.label : item.schema['latitude'].field)}</span>:&nbsp;
                {data && data[index] ? ((data[index]['latitude'] && data[index]['latitude']) || (latitude) || 0).toFixed(6) : ''}
              </div>
              <div className={'asset-details-section'}>
                <span
                  className={'asset-details-heading'}>{sanitizeFieldName(item.schema['longitude'].options.label ? item.schema['longitude'].options.label : item.schema['longitude'].field)}</span>:&nbsp;
                {data && data[index] ? ((data[index]['longitude'] && data[index]['longitude']) || (longitude) || 0).toFixed(6) : ''}
              </div>
            </div>

            <Form.Item style={{ display: 'none' }}>
              {getFieldDecorator(`${field}[${index}][fileData]`, {
                rules: false, message: '',
                initialValue: '',
              })(<Input style={{ display: 'none' }} />)
              }
            </Form.Item>

            {this.canRemove() && data && data[index] && (
              <div className={'asset-details-section'} style={{ marginTop: 8 }}>
                <Button type='danger' size='small' icon='delete'
                  onClick={() => this.confirmRemove(data[index]['_id'], tempCode)}>
                  Remove
                </Button>
              </div>
            )}
          </div>
          {
            (data && data[index] && data[index].photos) ? <div className='document-upload'>
              <div className={'asset-details-heading-photo'}>Photos</div>
              {
                data && data[index] && data[index].photos && data[index].photos.length ? (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {data[index].photos.map((itm, ix) => (
                      <img
                        key={itm.url}
                        src={itm.url}
                        alt={itm.name || `Attachment ${ix + 1}`}
                        title={itm.name || `Attachment ${ix + 1}`}
                        onClick={() => this.openPhotoPreview(data[index].photos, ix)}
                        style={{
                          width: 56,
                          height: 56,
                          objectFit: 'cover',
                          borderRadius: 4,
                          border: '1px solid #d9d9d9',
                          cursor: 'pointer',
                        }}
                      />
                    ))}
                  </div>
                ) : 'No Attachments'
              }
              <AddPhoto
                isApproved={this.props.isApproved}
                key={`photo-${tempCode}-${index}`}
                data={{
                  ...data[index],
                  _id: this.props.pv,
                  index: index // Add index to track which item this belongs to
                }}
                onUpload={(uploadData) => {
                  // console.log('Upload callback for index:', index, 'with data:', uploadData);
                  this.props.onSubmitWithDocument(uploadData);
                }}
              />
            </div> : <> </>
          }
        </div>
      )
    }
    );

    return (
      <div className='stock-taking-sublist'>
        {formItems}
        <br />
        <ImagePreviewModal
          visible={this.state.photoPreview.visible}
          photos={this.state.photoPreview.photos}
          initialIndex={this.state.photoPreview.index}
          onClose={this.closePhotoPreview}
        />
        <EditFieldModal
          visible={this.state.editModal.visible}
          field={this.state.editModal.field}
          title={this.editIconTitles[this.state.editModal.field] || 'Edit'}
          currentValue={this.state.editModal.currentValue}
          conditionOptions={this.getConditionOptions()}
          onSave={this.handleFieldSave}
          onCancel={this.closeEditModal}
        />
      </div>
    );
  }
}

export default SubList;
SubList.defaultProps = {};

SubList.propTypes = {
  item: PropTypes.object,
};
